import * as React from "react";
import { gql, useQuery } from "@apollo/client";
import {
  FindAllCommunityEntitiesQueryQuery,
  NewCommunityEntitySubscriptionSubscription
} from "../../../../schemaTypes";

export const findAllCommunityEntitiesQuery = gql`
  query FindAllCommunityEntitiesQuery {
    findAllCommunityEntities {
      id
      name
      shortName
      entityType
    }
  }
`;

export const newCommunityEntitySubscription = gql`
  subscription NewCommunityEntitySubscription {
    newCommunityEntity {
      id
      name
      shortName
      entityType
      createdBy {
        id
      }
      createdAt
      updatedAt
    }
  }
`;

export function useFindAllCommunityEntities() {
  const { data, loading, subscribeToMore } = useQuery<
    FindAllCommunityEntitiesQueryQuery
  >(findAllCommunityEntitiesQuery);

  React.useEffect(() => {
    if (!subscribeToMore) return;

    const unsubscribe = subscribeToMore({
      document: newCommunityEntitySubscription,
      updateQuery: (prev, { subscriptionData }: {
        subscriptionData: { data?: NewCommunityEntitySubscriptionSubscription }
      }) => {
        if (!subscriptionData.data) return prev;

        const newCommunityEntity = subscriptionData.data.newCommunityEntity;
        const newCommunityEntityPwa: FindAllCommunityEntitiesQueryQuery["findAllCommunityEntities"][number] = {
          __typename: "CommunityEntityPWA",
          id: newCommunityEntity.id,
          name: newCommunityEntity.name,
          shortName: newCommunityEntity.shortName,
        };

        const alreadyExists = prev.findAllCommunityEntities.some(
          (communityEntity) => communityEntity.id === newCommunityEntityPwa.id
        );

        if (alreadyExists) {
          return prev;
        }

        return {
          ...prev,
          findAllCommunityEntities: [...prev.findAllCommunityEntities, newCommunityEntityPwa]
            .sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: "base" }))
        };
      }
    });

    return () => unsubscribe();
  }, [subscribeToMore]);

  return {
    communityEntities: data?.findAllCommunityEntities ?? [],
    loading
  };
}
